module.exports = __webpack_public_path__ + "static/media/1.cc0322bc.jpg";